import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FiProfileSizes, IUserProfile } from '@fi-shared/profile-icon/profile-icon.component';
import { AppTextService } from '@fi-shared/app-text';

@Component({
    selector: 'fi-task-v2-creator-editor',
    templateUrl: './task-v2-creator-editor.component.html',
    styleUrl: './task-v2-creator-editor.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-task-v2-creator-editor' },
    standalone: false,
})
export class TaskV2CreatorEditorComponent {
    @Input({ required: true }) creatorProfile: IUserProfile;
    @Input() editorProfile: IUserProfile;
    @Input() createdOn: string;
    @Input() changedOn: string;
    @Input() isAutomatedTask: boolean = false;
    @Input() checklistName: string;
    @Output() userDetailsClicked = new EventEmitter<number>();

    protected readonly FiProfileSizes = FiProfileSizes;

    constructor(private appTextService: AppTextService) {}

    protected openUserDetails(userId: number): void {
        this.userDetailsClicked.emit(userId);
    }

    protected getAutomatedTaskText(): string {
        return this.appTextService.get('task.automated_from_checklist', { '{0}': this.checklistName });
    }
}
